import { Outlet, useLocation, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Breadcrumbs, type ITabItem, type ITooltipProps, Tabs, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { SettingsRoutes } from 'entities/ExportRouters'
import { InboxesRoutes } from 'pages/settings/pages/inboxes/route/type'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import styles from './styles.module.scss'

const getTabs = ({ isRcs }: { isRcs: boolean }): ITabItem[] => {
  const numbersTooltipProps: ITooltipProps | undefined = isRcs
    ? { label: 'RCS does not support Numbers', placement: 'top' }
    : undefined

  return [
    { key: 'members', name: 'Members' },
    {
      key: 'numbers',
      name: 'Numbers',
      disabled: isRcs,
      tooltipProps: numbersTooltipProps,
    },
    {
      key: 'settings',
      name: 'Settings',
    },
  ]
}

export const InboxByIdView = observer(() => {
  const { currentTeam } = useInboxLayerContext()
  const { pathname } = useLocation()
  const { id } = useParams()

  if (!currentTeam) return null
  const pathNames = pathname.split('/')
  const isSettingsPage =
    pathNames.includes(InboxesRoutes.messaging) || pathNames.includes(InboxesRoutes.calling)

  return (
    <div className={classNames(styles.content, styles.contentSettingsPage)}>
      <Breadcrumbs
        className={styles.breadcrumbs}
        customPath={`/${SettingsRoutes.root}/${InboxesRoutes.root}`}
      />
      <header className={styles.header}>
        <Typography variant='heading-lg' ariaLabel='InboxIdLayout_title'>
          {currentTeam?.name || ''}
        </Typography>
      </header>
      <div
        className={classNames(styles.tabsContainer, {
          [styles.tabsContainerSettingsPage]: isSettingsPage,
        })}
      >
        <Tabs
          tabs={getTabs({ isRcs: currentTeam?.is_rcs || false })}
          activeTabKey={isSettingsPage ? 'settings' : pathNames.pop()}
          handleSelectTab={({ key }) =>
            uiStore.changeRoute({
              path: `${SettingsRoutes.root}/${InboxesRoutes.root}/${id}/${key}`,
            })
          }
        />
      </div>
      <div className={styles.tabsContent}>
        <Outlet />
      </div>
    </div>
  )
})
